import { useContext } from "react";
import { useSelector } from "react-redux";

import Multimedia from "@sharedComponents/multimedia";
import { getCountryFlagUrl } from "@stadium/ui/src/shared/country-flag";

import Loaders from "@stadium/ui/src/components/loaders/loaders";

import SendItemsSelectionCart from "@components/store/cart/send-to-many/send-items-selection-cart";
import CountryWiseCartListing from "@sharedComponents/cart/send-to-many/countrywise-cart-listing";
import SendToOthersItemName from "@components/store/cart/send-to-many/send-to-others-item-name";

import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import { useConfig } from "@stadium/hooks/lib/use-config";

import { useSendItemsContext } from "@contexts/send-items-context";

import { getCartProductZoneList } from "@selectors/cart";
import { getGlobalCountryZoneId } from "@stadium/redux-utils/selectors/configSelector";

import { GLOBAL_COUNTRY_ISO } from "@stadium/helpers/country/constants";

import GlobalRedemptionInfoTip from "@sharedComponents/cart/global-redemption-info-tip";

import styles from "./main.module.scss";

const emptyObj = {};

const globalCountryFlagUrl = getCountryFlagUrl({ iso: GLOBAL_COUNTRY_ISO }, "round");

const SendToOthersCart = ({ cartProductsData = emptyObj }) => {
  const cartProductZoneList = useSelector(getCartProductZoneList);
  const globalCountryZoneId = useConfig(getGlobalCountryZoneId);

  const isProductFromSingleCountry = cartProductZoneList.length === 1;

  const showSendToAnotherCountryBanner =
    isProductFromSingleCountry && cartProductZoneList[0] !== +globalCountryZoneId;

  const { variantData, variantDataloading, variantsMapping } = cartProductsData;

  const { isMobileDevice } = useContext(CurrentDeviceContext);

  const { showSendToManyOption } = useSendItemsContext();

  const showKitNameAtBottom = (!isProductFromSingleCountry && !isMobileDevice) || isMobileDevice;

  if (variantDataloading)
    return (
      <div>
        <Loaders.PageLoader wrapperClass="pageLoaderwrap cartPageLoader" />
      </div>
    );

  return (
    <div className={styles.sendToOthersBlock}>
      <section className={styles.headerRow}>
        <div className={`${styles.leftBlock} ${styles.extraClass}`}>
          {showSendToManyOption && <SendItemsSelectionCart />}
        </div>
        <div className={`${styles.rightBlock} ${styles.extraClass}`}>
          {showSendToAnotherCountryBanner && (
            <div className={styles.countryRecipientsBlock}>
              <div className={styles.globeImage}>
                <Multimedia
                  alt="global-flag-image"
                  type="image"
                  src={globalCountryFlagUrl}
                  width={24}
                  height={24}
                />
              </div>
              <div className={styles.countryRecipientsBlockInfo}>
                <div className={styles.title}>Sending items to recipients in another country?</div>
                <div className={styles.countryInfoText}>
                  Select a country from above to see items available in that country. Recipients
                  will be able to redeem from countries currently shown in your bag and will enter
                  sizes and addresses during redemption.
                  <GlobalRedemptionInfoTip
                    isGlobalZoneSelected
                    iconInfoClass={styles.iconInfo}
                    learnMoreClass={styles.learnMore}
                    toolTipWrapperClass={styles.tooltipWrapperGlobal}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
      <div className={styles.countryWiseRow}>
        <CountryWiseCartListing
          variantDataloading={variantDataloading}
          variantsMapping={variantsMapping}
          variantData={variantData}
        />
      </div>
      {showKitNameAtBottom && <SendToOthersItemName />}
    </div>
  );
};

export default SendToOthersCart;
